<template>
  <v-col :cols="block.cols" :xs="block.colsxs" :sm="block.colssm" :md="block.colsmd" :lg="block.colslg" :xl="block.colsxl" :offset="block.offset">
    <v-switch v-model="form[block.checkbox]" :label="block.label" />

    <v-row class="ml-16" align="center">
      <template v-for="optionalBlock in block.optionalComponents">
        <component :is="optionalBlock.component" :key="optionalBlock.uid" v-model="form[optionalBlock.uid]" :block="optionalBlock" />
      </template>
    </v-row>
  </v-col>
</template>

<script>
export default {
   name: 'Optional',
   model: {
      prop: 'form',
      event: 'update:form'
   },

   props: {
      block: {
         type: Object,
         required: true,
      },
      form: {
         type: Object,
         required: true,
      },
   },

   data () {
      return {
         show: false
      }
   },
   computed: {
      icon () {
         return this.form[this.block.checkbox] ? 'mdi-minus' : 'mdi-plus'
      }
   },

   watch: {
      form: {
         deep: true,
         handler (val, oldVal) {
            this.$emit('update:form', this.form)
         }
      }
   },

   created () {
      for (const optionalKey in this.form) {
         console.log(optionalKey)
         if (optionalKey[optionalKey] !== null && optionalKey[optionalKey] !== undefined) {
            this.show = true
         }
      }
   }
}
</script>
